import { Marker } from 'react-leaflet';
import L from 'leaflet';

interface CurrentLocationMarkerProps {
  latitude: number;
  longitude: number;
}

const currentLocationIcon = L.divIcon({
  html: `
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
      style="filter: drop-shadow(0 1px 3px rgba(0,0,0,0.4));">
      <path d="M3 11L22 2L13 21L11 13L3 11Z" stroke="#007AFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `,
  className: '',
  iconSize: [28, 28],
  iconAnchor: [14, 14],
});

export function CurrentLocationMarker({ latitude, longitude }: CurrentLocationMarkerProps) {
  return <Marker position={[latitude, longitude]} icon={currentLocationIcon} />;
}
